export function currencyToSelect(currencies) {
    let cleanedCurrencies = [];

    currencies.map((item) => (
        cleanedCurrencies.push({
            label: item.name + " (" + item.symbol + ") - " + item.isoCode,
            value: item.id,
            item: item,
        })
    ));

    return cleanedCurrencies;
}



// WEBPACK FOOTER //
// ./src/utils/currency.js